import Tasks from '~/components/maud/tasks';

const TasksPage = () => <Tasks />;

export default TasksPage;
